import { render, staticRenderFns } from "./cms-block-world-map.vue?vue&type=template&id=7f8fbffe&scoped=true"
import script from "./cms-block-world-map.vue?vue&type=script&lang=js"
export * from "./cms-block-world-map.vue?vue&type=script&lang=js"
import style0 from "./cms-block-world-map.vue?vue&type=style&index=0&id=7f8fbffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8fbffe",
  null
  
)

export default component.exports